import { createTheme } from '@material-ui/core/styles';

import { blue, common, red, green, orange, grey, yellow } from './colors';
import { typography } from './typography';

const palette = {
    primary: {
        main: blue[100],
        light: '#64B6F7',
        dark: blue[400],
        contrastText: common.white,
        background: '#EDF7FE',
        border: '#90CAF9',
    },
    secondary: {
        main: yellow[100],
        light: '#F06191',
        dark: yellow[200],
        contrastText: common.white,
        background: '#FBDCE7',
        border: '#F48EB1',
    },
    info: {
        main: blue[300],
        light: '#64B6F7',
        dark: blue[400],
        contrastText: common.white,
        lightBackground:
            'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3',
    },
    error: {
        main: red[300],
        light: '#F88078',
        dark: '#E31B0C',
        contrastText: common.white,
        lightBackground:
            'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336',
    },
    default: {
        main: red[300],
        light: '#F88078',
        dark: '#E31B0C',
        contrastText: common.white,
    },
    warning: {
        main: orange[100],
        light: '#FFB547',
        dark: '#C77700',
        contrastText: common.white,
        lightBackground:
            'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #FF9800',
    },
    success: {
        main: green[100],
        light: '#7BC67E',
        dark: '#3B873E',
        contrastText: common.white,
        lightBackground:
            'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #4CAF50',
    },
    text: {
        primary: common.dark,
        secondary: '#757575',
        disabled: grey[500],
    },
    divider: '#E0E0E0',
    action: {
        hover: blue[400],
        selected: '#EBEBEB',
        disabledBackground: '#E0E0E0',
        disabled: grey[400],
    },
    background: {
        default: common.white,
    },
    contrastThreshold: 3,
    border: {
        main: grey[300],
    },
    blue,
    red,
    green,
    common,
    grey,
    yellow,
    orange,
};

const theme = createTheme({
    palette,
    typography
});

export default theme;
